import React, { useEffect, useState } from 'react';
import { map } from 'lodash-es';
import { useScroll } from 'ahooks';
import classnames from 'classnames/bind';
import { useLocation } from 'react-router-dom';
import { useAntLocale } from '@fuxi/eevee-hooks';
import { useTranslation } from 'react-i18next';
import { ContactType } from '@commonPackage/constants';
import { checkIsProd } from 'common-package/src/utils';
import { useUserInfo } from 'common-package';
import { toContactPage, toDemoCloudGamePageWithTourist } from 'portal-common/src/utils';
import { YsfConfig } from 'common-package/src/types';
import { useYaotaiGlobalContextState } from '@commonPackage/contexts';

import { EN } from '@yaotai/common-utils';
import { BASIC_LAYOUT_ID } from '@/constants';
import IconContact from '@/assets/svg/icon-contact.svg';
import IconContactCorner from '@/assets/svg/icon-contact-corner.svg';
import IconPhone from '@/assets/svg/icon-phone.svg';
import IconEmail from '@/assets/svg/icon-email.svg';
import IconYaoTai from '@/assets/svg/icon-yaotai.svg';
import styles from './index.module.less';

const cx = classnames.bind(styles);

const CONTACT_MESSAGE = {
  phone: '(0571)89852163转21951',
  email: 'fuxi@service.netease.com',
};

const VISIBILITY_HEIGHT = 120;

export const ContactBox = () => {
  const {
    commonUrls: { demoAid, cloudGameUrl },
  } = useYaotaiGlobalContextState();
  const { top } = useScroll(document.getElementById(BASIC_LAYOUT_ID) || document) || { top: 0 };
  const userInfo = useUserInfo({ monorepoType: 'center' });
  const location = useLocation();
  const { t } = useTranslation();
  const { language } = useAntLocale();

  const isHomePage = location.pathname === '/';

  const contactContent = [
    {
      icon: IconPhone,
      title: '联系电话',
      desc: CONTACT_MESSAGE.phone,
      hide: language === EN,
    },
    {
      icon: IconEmail,
      title: t('footer.email'),
      desc: CONTACT_MESSAGE.email,
    },
    {
      icon: IconYaoTai,
      title: checkIsProd() ? t('footer.free1') : t('footer.free'),
      desc: t('footer.subtitle'),
      onClick: (options?: YsfConfig) => {
        if (checkIsProd()) {
          toDemoCloudGamePageWithTourist(demoAid);
        } else {
          toContactPage({
            contactType: ContactType.cooperation,
            isMain: import.meta.env.VITE_MAIN === 'true',
          });
        }
      },
    },
  ];

  const [visible, setVisible] = useState(() => {
    return isHomePage ? false : true;
  });

  useEffect(() => {
    isHomePage && setVisible(top > VISIBILITY_HEIGHT);
  }, [isHomePage, top]);

  return (
    <div
      className={cx('contact-wrapper', { height: language === EN })}
      style={{ visibility: visible ? 'visible' : 'hidden', opacity: visible ? 1 : 0 }}>
      <div className={cx('icon-wrapper')}>
        <img src={IconContact} alt="icon" />
      </div>
      <div className={cx('contact-box')}>
        <div className={cx('content-box', { 'box-height': language === EN })}>
          {map(
            contactContent.filter(i => !i.hide),
            ({ icon, title, desc, onClick }) => (
              <div
                key={title}
                onClick={() => {
                  onClick?.({ userInfo });
                }}
                className={cx('content-item')}>
                <div className={cx('left-content')}>
                  <img src={icon} className={cx('left-content-icon')} alt="icon" />
                </div>
                <div className={cx('right-content')}>
                  <p>{title}</p>
                  <p>{desc}</p>
                </div>
              </div>
            )
          )}
          <img src={IconContactCorner} className={cx('icon-corner')} alt="icon" />
        </div>
      </div>
    </div>
  );
};

export default ContactBox;
